<script>
import DateRangePicker from '@/components/general/date-range-picker.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      menuOpen: false,
      selectedCommentTypes: [],
      fromDate: '',
      untilDate: '',
      searchInput: '',
    }
  },
  computed: {
    ...mapState('comments', {
      currentModule: (state) => state.cached.module,
      filters: (state) => state.cached.candidate.filters,
      storeFromDate: (state) =>
        state.cached[state.cached.module].filters.fromDate,
      storeUntilDate: (state) =>
        state.cached[state.cached.module].filters.untilDate,
      storeCommentTypes: (state) =>
        state.cached[state.cached.module].filters.commentTypes,
      allCommentTypes: (state) => state.cached.allCommentTypes,
    }),
  },
  mounted() {
    if (this.currentModule.length) {
      this.selectedCommentTypes = this.storeCommentTypes
      this.selectedFromDate = this.storeFromDate
      this.selectedUntilDate = this.storeUntilDate
    }
  },
  methods: {
    updateDate({ date, key }) {
      this[key] = date
    },
    applyFilters() {
      this.$store.commit('comments/SET_FILTERS', {
        key: 'fromDate',
        value: this.fromDate,
      })
      this.$store.commit('comments/SET_FILTERS', {
        key: 'untilDate',
        value: this.untilDate,
      })
      this.$store.commit('comments/SET_FILTERS', {
        key: 'commentTypes',
        value: this.selectedCommentTypes,
      })

      this.searchInput = ''
      this.menuOpen = false
    },
    clearFilters() {
      this.selectedCommentTypes = []
      this.fromDate = ''
      this.untilDate = ''
      this.$refs.dateRangePicker.clearDate()
    },
    closeFilters() {
      this.selectedCommentTypes = this.storeCommentTypes
      this.fromDate = this.storeFromDate
      this.untilDate = this.storeUntilDate
      this.$refs.dateRangePicker.clearDate()
      this.menuOpen = false
    },
    removeCommentType(id) {
      this.selectedCommentTypes = this.selectedCommentTypes.filter(
        (typeId) => typeId !== id
      )
    },
  },
}
</script>

<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    :close-on-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        elevation="2"
        class="filter-button pa-2"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="white" size="25">mdi-filter-variant</v-icon>
        <span class="text-h6 ml-2">Filter</span>
      </v-btn>
    </template>

    <v-card class="px-8 py-12 menu-card">
      <p class="text-h5 mb-8 font-weight-medium">
        <span class="mr-2">
          <v-icon color="primary" size="35">mdi-calendar-range</v-icon>
        </span>
        Date Range
      </p>
      <DateRangePicker ref="dateRangePicker" @updateDate="updateDate" />
      <p class="text-h5 mt-16 pt-8 mb-8 font-weight-medium">
        <span class="mr-2">
          <v-icon color="primary" size="35">mdi-shape</v-icon>
        </span>
        Type
      </p>

      <v-autocomplete
        v-model="selectedCommentTypes"
        :items="allCommentTypes"
        deletable-chips
        item-text="description"
        item-value="id"
        placeholder="Search or select comment types"
        multiple
        hide-details
        :search-input="searchInput"
        class="mt-0 pt-0 pb-8"
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            color="rgba(0, 172, 239, 0.2)"
            class="mr-2 mb-2"
            text-color="primary darken-2"
            label
            close
            @click="data.select"
            @click:close="removeCommentType(data.item.id)"
          >
            {{ data.item.description }}
          </v-chip>
        </template>
      </v-autocomplete>

      <v-card-actions class="pa-0 mt-16">
        <v-btn class="pa-6" color="gray lighten-2" text @click="closeFilters">
          Close
        </v-btn>
        <v-btn class="pa-6" color="error" text @click="clearFilters">
          Clear
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed class="pa-6" color="primary" @click="applyFilters">
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style scoped lang="scss">
.filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
  margin-right: 8px;
}

.filters-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.chip-wrapper {
  display: flex;
  flex-flow: row wrap;
}

.menu-card {
  width: 600px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
}
</style>
